import { domain } from 'modules/data';
import { useNetSuiteInvoiceFieldSettings } from 'shared/hooks';
import { z } from 'zod';

import { isMandatoryFieldEmpty } from '../NetSuiteRequestForm/NetSuiteRequestForm.helpers';
import { messages } from './InvoiceShippingDetailsSection.messages';

const createFieldSchema = (fieldSetting: domain.DocumentFieldState) =>
    z
        .string()
        .nullable()
        .refine((value) => !isMandatoryFieldEmpty(value, fieldSetting), {
            message: messages.fieldRequired,
        });

export const createSchema = (fieldSettings: ReturnType<typeof useNetSuiteInvoiceFieldSettings>) => {
    const schema = {
        shipDate: createFieldSchema(fieldSettings.shippingDate),
        shipMethod: createFieldSchema(fieldSettings.shippingMethod),
        shippingAddress: createFieldSchema(fieldSettings.shippingAddress),
    };

    return z.object(schema);
};
